import { createBEM } from "@/libs";
import { ComponentBase } from "@/types";
import "./index.scss";
export interface LevelProps extends ComponentBase.BaseComponent {
  level: number;
}
export const Level = ({
  level = 1,
  ...attrs
}: LevelProps) => {
  const b = createBEM("i-level");
  const levelModel = level % 5;
  const _level = levelModel >= 1 ? (level - levelModel) / 5 + 1 : level / 5;
  return <div className={b()} {...attrs} data-sentry-component="Level" data-sentry-source-file="index.tsx">
      {Array(5).fill(0).map((item, index) => {
      const _le = index + 1;
      return <div className={b("icon", [_level], {
        up: _le === 5 ? levelModel === 0 : levelModel >= _le || levelModel === 0
      })} key={_le}>
              {/* {_le} */}
            </div>;
    })}
    </div>;
};